import styled from 'styled-components';

export const StyledSection = styled.section`
  width: 100%;
  padding: 0;
  margin: 0 0 32px;
`;
